import React, { Component } from "react";
import SmartLink from "../shared/links/SmartLink";
import styles from "../../assets/css/modules/homecard/home-card.css";
import ExternalLinkLG from "../../assets/img/ExternalLinkLG.png";
import { Urls } from "../../constants/UrlConstants";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";

export class HomeCard extends Component {
  constructor(props) {
      super(props);
      this.state = {
        urlGetInTouch:Urls.EngagementPortal[EPDomain_ROOT].newmessage
      };
    }

    handleCallbackGetInTouch = (url) => {
      this.setState({ urlGetInTouch: url });
    };

  render() {
    let linkTo = this.props.LinkTo
      ? this.props.LinkTo 
      : this.props.ExternalLinkTo;
            
    return (
      <div className={this.props.Healthsupport1==="HealthSupport"?styles.homeCardLgHeight:this.props.carouselData==="carouselDatas"?styles.carouselCard:styles.homeCard}>
        <EPQueryParams url={this.state.urlGetInTouch} updatedURL={this.handleCallbackGetInTouch}/>
        {this.props.iclass ? (
          <i className={this.props.iclass} />
        ) : (
          <img
            src={this.props.IconSrc}
            className={this.props.carouselData==="carouselDatas"?styles.carouselImage:styles.cardImage}
            alt=""
            aria-hidden
          />
        )}
        <div className={styles.content}>
        <h2>{this.props.Heading}</h2>
        {this.props.Description && this.props.Description.map ? (
          this.props.Description.map((desc, idx) => (
            <p key={idx} className="my-1">
              {desc}
            </p>
          ))
        ) : (
          <p className="my-2">{this.props.Description}</p>
        )}
  </div>
        <div className={styles.smartLink}>
          <SmartLink
            isExternalLink={!!this.props.ExternalLinkTo}
            to={this.props.LinkText === "Get in touch"? this.state.urlGetInTouch : linkTo}
            className={this.props.isDisabled? styles.disablecardLink: styles.cardLink}
            id={this.props.id}
            isDisabled={this.props.isDisabled}
            disableStyle={!this.props.isDisabled}
          >
             {/* ➔ */}
            {this.props.LinkText} 
            &nbsp;
            {this.props.carouselData==="carouselDatas"?"➔":""}
            <span className="ml-2">
              {/* {this.props.externalNav==="externalNav"? <img src ={ExternalLinkLG} alt="ExternalLinkLG"></img>:"➔"}</span> */}
              {this.props.externalNav==="externalNav"? <img src ={ExternalLinkLG} alt="ExternalLinkLG"></img>:""}</span>             
          </SmartLink>
        </div>
     
      </div>
    );
  }
}

export default HomeCard;
